module.exports = __webpack_public_path__ + "img/changeFinish-2.ffee46b.png";